if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;

        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);

            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            this.addViewFullDetailsButton(opener);
            this.setupQuickAddGallery();
            this.triggerAppReloads();

            setTimeout(() => {
              this.moveViewFullDetailsButtonMobile(opener);
            }, 650);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      addViewFullDetailsButton(opener) {
        const productUrl = opener.getAttribute('data-product-url');
        if (!productUrl) return;

        const existingButton = this.modalContent.querySelector('.rlh-quick-view-details');
        if (existingButton) existingButton.remove();

        const link = document.createElement('a');
        link.href = productUrl;
        link.className = 'button button--secondary rlh-quick-view-details';
        link.textContent = 'View full details';

        const mediaWrapper = this.modalContent.querySelector('.product__media-wrapper');
        if (mediaWrapper) mediaWrapper.appendChild(link);

        this.moveViewFullDetailsButtonMobile(opener);
      }

      moveViewFullDetailsButtonMobile(opener) {
        if (!window.matchMedia('(max-width: 749px)').matches) return;

        const button = this.modalContent.querySelector('.rlh-quick-view-details');
        if (!button) return;

        const infoWrapper = this.modalContent.querySelector('.product__info-wrapper');
        if (!infoWrapper) return;

const variantPicker =
  infoWrapper.querySelector('variant-selects') ||
  infoWrapper.querySelector('variant-radios') ||
  infoWrapper.querySelector('.product-form__input');

if (variantPicker) {
  variantPicker.insertAdjacentElement('beforebegin', button);
} else {
          const variantPicker = infoWrapper.querySelector('variant-selects, variant-radios, .product-form__input');
          if (variantPicker) {
            variantPicker.insertAdjacentElement('beforebegin', button);
          } else {
            infoWrapper.appendChild(button);
          }
        }
      }

      setupQuickAddGallery() {
        const mediaWrapper = this.modalContent.querySelector('.product__media-wrapper');
        const mediaList = this.modalContent.querySelector('.product__media-list');
        const mediaItems = Array.from(this.modalContent.querySelectorAll('.product__media-item'));

        if (!mediaWrapper || !mediaList || mediaItems.length === 0) return;

        let activeIndex = 0;
        let startX = 0;

        mediaWrapper.classList.add('rlh-quick-gallery');

        const updateGallery = () => {
          mediaItems.forEach((item, index) => {
            if (index === activeIndex) {
              item.classList.add('rlh-active-media');
              item.style.display = 'block';
            } else {
              item.classList.remove('rlh-active-media');
              item.style.display = 'none';
            }
          });

          const count = mediaWrapper.querySelector('.rlh-quick-gallery-count');
          if (count) count.textContent = `${activeIndex + 1} / ${mediaItems.length}`;
        };

        mediaWrapper.querySelector('.rlh-quick-gallery-controls')?.remove();

        if (mediaItems.length > 1) {
          const controls = document.createElement('div');
          controls.className = 'rlh-quick-gallery-controls';

          const prev = document.createElement('button');
          prev.type = 'button';
          prev.className = 'rlh-quick-gallery-arrow';
          prev.setAttribute('aria-label', 'Previous image');
          prev.textContent = '‹';

          const count = document.createElement('span');
          count.className = 'rlh-quick-gallery-count';

          const next = document.createElement('button');
          next.type = 'button';
          next.className = 'rlh-quick-gallery-arrow';
          next.setAttribute('aria-label', 'Next image');
          next.textContent = '›';

          prev.addEventListener('click', () => {
            activeIndex = activeIndex === 0 ? mediaItems.length - 1 : activeIndex - 1;
            updateGallery();
          });

          next.addEventListener('click', () => {
            activeIndex = activeIndex === mediaItems.length - 1 ? 0 : activeIndex + 1;
            updateGallery();
          });

          mediaList.addEventListener(
            'touchstart',
            (event) => {
              startX = event.touches[0].clientX;
            },
            { passive: true }
          );

          mediaList.addEventListener(
            'touchend',
            (event) => {
              const endX = event.changedTouches[0].clientX;
              const diff = startX - endX;

              if (Math.abs(diff) < 40) return;

              if (diff > 0) {
                activeIndex = activeIndex === mediaItems.length - 1 ? 0 : activeIndex + 1;
              } else {
                activeIndex = activeIndex === 0 ? mediaItems.length - 1 : activeIndex - 1;
              }

              updateGallery();
            },
            { passive: true }
          );

          controls.appendChild(prev);
          controls.appendChild(count);
          controls.appendChild(next);
          mediaList.after(controls);
        }

        updateGallery();
      }

      triggerAppReloads() {
        setTimeout(() => {
          try {
            document.dispatchEvent(new Event('shopify:section:load'));
            document.dispatchEvent(new Event('swatch:loaded'));

            if (window.SwatchKing && typeof window.SwatchKing.init === 'function') {
              window.SwatchKing.init();
            }

            if (window.SwatchKing && typeof window.SwatchKing.load === 'function') {
              window.SwatchKing.load();
            }

            if (window.swatchKing && typeof window.swatchKing.init === 'function') {
              window.swatchKing.init();
            }
          } catch (e) {
            console.warn('Quick add app reload failed', e);
          }
        }, 500);
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient') {
            this.modalContent.classList.add(classApplied);
          }
        });

        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;

        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);

        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');

        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');

        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');

        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

document.addEventListener('change', function (event) {
  if (!event.target.closest('quick-add-modal')) return;

  const modal = event.target.closest('quick-add-modal');
  const scrollBox =
    modal.querySelector('.quick-add-modal__content-info') ||
    modal.querySelector('.quick-add-modal__content');

  if (!scrollBox) return;

  const savedScrollTop = scrollBox.scrollTop;

  requestAnimationFrame(() => {
    scrollBox.scrollTop = savedScrollTop;

    setTimeout(() => {
      scrollBox.scrollTop = savedScrollTop;
    }, 120);

    setTimeout(() => {
      scrollBox.scrollTop = savedScrollTop;
    }, 350);
  });
});